import React, { useState, useEffect } from 'react'
import { get, orderBy } from 'lodash'
import CriteriaTreeItem from './CriteriaTreeItem'
import ChoiceTreeItem from './ChoiceTreeItem'

const Criteria = ({ criteria, parentNodeId = '', parentCriteria = '' }) => {
  const nodeId = `${parentNodeId}${parentNodeId ? '/' : ''}cri-${criteria.id}`
  const [orderDirection, setOrderDirection] = useState('desc')

  useEffect(() => {
    if (parentCriteria.criteria_type === 'checkbox_extended') {
      setOrderDirection('asc')
    }
  }, [criteria, parentCriteria])

  return (
    <CriteriaTreeItem
      id={`criteria${criteria.id}`}
      tabIndex="0"
      nodeId={nodeId}
      criteria={criteria}
      label={criteria.name}
      explanation={criteria.explanation}
    >
      {orderBy(
        get(criteria, 'choices', []),
        ['is_text_or_extended'],
        [orderDirection],
      ).map((choice, index) => {
        const choiceNodeId = `${nodeId}/cho-${index}`

        return (
          <ChoiceTreeItem
            tabIndex="0"
            key={choiceNodeId}
            parentCriteria={criteria}
            choice={choice}
            nodeId={choiceNodeId}
          >
            {get(choice, 'linked_criterias', []).map((linkedCriteria) => (
              <Criteria
                key={linkedCriteria.id}
                criteria={linkedCriteria}
                parentNodeId={choiceNodeId}
                parentCriteria={criteria}
              />
            ))}
          </ChoiceTreeItem>
        )
      })}
    </CriteriaTreeItem>
  )
}

export default Criteria
